import React, { createContext, useCallback, useContext, useState } from 'react'

import ICaminhao from 'modules/caminhao/domain/entities/Caminhao'
import IMotorista from 'modules/motorista/domain/entities/IMotorista'

import IFindByIdResponse from '../domain/entities/FindByIdResponse'

export interface IDirecionaCargaContextState {
  motorista: IMotorista
  setMotorista: (motorista: IMotorista) => void
  caminhao: ICaminhao
  setCaminhao: (caminhao: ICaminhao) => void
  lote: IFindByIdResponse
  setLote: (lote: IFindByIdResponse) => void
  cidadeOrigem: string
  setCidadeOrigem: (cidadeOrigem: string) => void
  cidadeDestino: string
  setCidadeDestino: (cidadeDestino: string) => void
  clearDirecionarCarga(): void
  contaPendencias: boolean
  setContaPendencias: (value: boolean) => void
}

export const DirecionaCargaContext = createContext<IDirecionaCargaContextState>(
  {} as IDirecionaCargaContextState,
)

export function useDirecionaCarga(): IDirecionaCargaContextState {
  const context = useContext(DirecionaCargaContext)

  if (!context) {
    throw new Error(
      'useDirecionaCarga must be used within an DirecionaCargaProvider',
    )
  }

  return context
}

export const DirecionaCargaProvider: React.FC = ({ children }) => {
  const [motorista, setMotorista] = useState<IMotorista>()
  const [caminhao, setCaminhao] = useState<ICaminhao>()
  const [lote, setLote] = useState<IFindByIdResponse>()
  const [cidadeOrigem, setCidadeOrigem] = useState('')
  const [cidadeDestino, setCidadeDestino] = useState('')
  const [contaPendencias, setContaPendencias] = useState(false)

  const clearDirecionarCarga = useCallback(() => {
    setMotorista(null)
    setCaminhao(null)
    setLote(null)
    setCidadeOrigem('')
    setCidadeDestino('')
  }, [])

  const setContaPendenciasValue = (value: boolean) => {
    setContaPendencias(value)
  }

  return (
    <DirecionaCargaContext.Provider
      value={{
        motorista,
        setMotorista,
        caminhao,
        setCaminhao,
        lote,
        setLote,
        cidadeOrigem,
        setCidadeOrigem,
        cidadeDestino,
        setCidadeDestino,
        clearDirecionarCarga,
        contaPendencias,
        setContaPendencias: setContaPendenciasValue,
      }}
    >
      {children}
    </DirecionaCargaContext.Provider>
  )
}
